<template>
  <v-col cols="12" md="3" sm="12">
    <v-card :loading="loading" class="mx-auto" height="180">
      <template slot="progress">
        <v-progress-linear color="indigo" indeterminate></v-progress-linear>
      </template>

      <v-card-text class="text-h6 font-weight-black">Faixa Etária</v-card-text>

      <apexchart height="100" :options="chartOptions" :series="series"></apexchart>
    </v-card>
  </v-col>
</template>

<script>
export default {
  name: "FaixaEtariaCard",
  mounted() {
    this.getFaixaEtaria();
  },
  data() {
    return {
      loading: true,
      series: [0, 0, 0, 0], // Inicializa com zeros
      chartOptions: {
        chart: {
          height: 100,
          type: "donut",
          offsetX: -20,
        },
        legend: {
          show: true,
          position: "right",
          offsetY: 0,
          formatter(legendName, opts) {
            return `${legendName}: ${opts.w.globals.series[opts.seriesIndex]}`;
          },
        },
        labels: ["0-6 anos", "6-15 anos", "15-18 anos", "18+ anos"],
        colors: ["#008FFB", "#00E396", "#FEB019", "#FF4560"],
        responsive: [
          {
            breakpoint: 400,
            options: {
              chart: {
                width: 200,
              },
              legend: {
                position: "bottom",
                offsetY: 0,
              },
            },
          },
        ],
      },
    };
  },
  methods: {
    async getFaixaEtaria() {
      try {
        const response = await this.$services.alunosService.faixaEtaria();

        if (response.data && response.data.length > 0) {
          const faixas = response.data[0];
          this.series = [
            parseInt(faixas.de0a6, 10) || 0,
            parseInt(faixas.de6a15, 10) || 0,
            parseInt(faixas.de15a18, 10) || 0,
            parseInt(faixas.mais18, 10) || 0,
          ];
        }
      } catch (error) {
        // console.error("Erro ao buscar faixa etária:", error);
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
